<div class="p-3 bg-gray">
  <div class="row">
    <div class="d-flex justify-content-between align-items-center">
      <div class="font-white">
        <div class="fs-16 fw-normal">{{ companyID ? "Update" : "Create" }} Company</div>
      </div>
      <!-- <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" (click)="onClose()" tabindex="0" (keydown)="onClose()" class="cursor-pointer"></div> -->
    </div>
    <div class="border-bottom mb-2 mt-2"></div>
    <div class="col-12 mt-2">
      <app-document-upload displayAs="profile" category="Profile" [documents]="uploadedDocuments['Profile'] || []" (documentsChange)="updateDocuments($event)" (documentRemove)="removeFile($event)">
      </app-document-upload>
    </div>
    <div class="col-md-6 col-12 mt-2">
      <label for="companyName" class="fs-14 fw-normal font-white">Company Name</label>
      <input id="companyName" class="form-control bg-form-control border-0 font-white" onlyCharacter maxlength="45" [(ngModel)]="companyDetails.CompanyName" name="companyName" placeholder="Enter Company Name" />
    </div>

    <div class="col-md-6 col-12 mt-2">
      <label for="companyType" class="fs-14 fw-normal font-white">Company Type</label>
      <input id="companyType" class="form-control bg-form-control border-0 font-white" [(ngModel)]="companyDetails.CompanyType" name="companyType" placeholder="Enter Company Type" />
    </div>

    <div class="col-md-6 col-12 mt-2">
      <label for="contactNumber" class="fs-14 fw-normal font-white">Contact Number</label>
      <input
        id="contactNumber"
        class="form-control bg-form-control border-0 font-white"
        onlyNumber
        maxLength="10"
        [(ngModel)]="companyDetails.ContactNumber"
        name="contactNumber"
        placeholder="Enter Contact Number" />
    </div>

    <div class="col-md-6 col-12 mt-2">
      <label for="contactNumber" class="fs-14 fw-normal font-white">Email</label>
      <input id="contactNumber" class="form-control bg-form-control border-0 font-white" [(ngModel)]="companyDetails.PrimaryEmail" name="contactNumber" placeholder="Enter Contact Number" />
    </div>

    <div class="col-md-6 col-12 mt-2">
      <label for="companyName" class="fs-14 fw-normal font-white">Address</label>
      <input id="companyName" class="form-control bg-form-control border-0 font-white" maxlength="255" [(ngModel)]="companyDetails.Address" onlyCharacter name="companyName" placeholder="Enter Company Name" />
    </div>

    <div class="col-md-6 col-12 mt-2">
      <label for="companyName" class="fs-14 fw-normal font-white">City Name</label>
      <input id="companyName" class="form-control bg-form-control border-0 font-white" onlyCharacter maxlength="45" [(ngModel)]="companyDetails.City" name="companyName" placeholder="Enter Company Name" />
    </div>

    <div class="col-md-6 col-12 mt-2">
      <label for="companyType" class="fs-14 fw-normal font-white">State Name</label>
      <input id="companyType" class="form-control bg-form-control border-0 font-white" onlyCharacter maxlength="45" [(ngModel)]="companyDetails.State" name="companyType" placeholder="Enter Company Type" />
    </div>

    <div class="col-md-6 col-12 mt-2">
      <label for="companyType" class="fs-14 fw-normal font-white">Country Name</label>
      <input id="companyType" class="form-control bg-form-control border-0 font-white" onlyCharacter maxlength="45" [(ngModel)]="companyDetails.Country" name="companyType" placeholder="Enter Company Type" />
    </div>
    <div class="row">
      <div class="col-md-2 col-12 mt-2">
        <label for="contactNumber" class="fs-14 fw-normal font-white">CGST</label>
        <input id="contactNumber" class="form-control bg-form-control border-0 font-white" [(ngModel)]="companyDetails.CGST" allowDecimal name="contactNumber" placeholder="Enter Contact Number" />
      </div>
      <div class="col-md-2 col-12 mt-2">
        <label for="contactNumber" class="fs-14 fw-normal font-white">SGST</label>
        <input id="contactNumber" class="form-control bg-form-control border-0 font-white" [(ngModel)]="companyDetails.SGST" allowDecimal name="contactNumber" placeholder="Enter Contact Number" />
      </div>
      <div class="col-md-4 col-12 mt-2">
        <label for="contactNumber" class="fs-14 fw-normal font-white">PAN</label>
        <input id="contactNumber" class="form-control bg-form-control border-0 font-white" maxlength="10" [(ngModel)]="companyDetails.PAN" name="contactNumber" placeholder="Enter Contact Number" />
      </div>
      <div class="col-md-4 col-12 mt-2">
        <label for="contactNumber" class="fs-14 fw-normal font-white">GSTIN</label>
        <input id="contactNumber" class="form-control bg-form-control border-0 font-white" maxlength="15" [(ngModel)]="companyDetails.GSTIN" name="contactNumber" placeholder="Enter Contact Number" />
      </div>
    </div>

    <div class="d-flex justify-content-end mt-5">
      <button class="close-btn me-2 px-4 py-1 " (click)="onClose()">Close</button>
      <button class="add-btn px-4 py-1" (click)="onSubmit()">{{companyID ? "Update" : "Add"}}</button>
    </div>
  </div>
</div>
<!-- <div class="col-md-6 col-12">
    <app-multi-select-dropdown label="Region" placeholder="Select a region" [items]="regionList" valueProperty="RegionID" displayProperty="RegionName" [(model)]="regionList.RegionID">
    </app-multi-select-dropdown>
  </div> -->
